import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { hideSnackBarNotifications, hideError } from 'actions';

const NotificationToaster = () => {

  const dispatch = useDispatch();
  const commonState = useSelector(state => state.commonState);
  const session = useSelector(state => state.session);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (commonState.snackbar_notification !== '') {
      if ((commonState.snackbar_notification_type === 'general_error' || commonState.snackbar_notification_type === 'token_expire')) {
        enqueueSnackbar(commonState.snackbar_notification,
          {
            variant: 'error',
            onClose: handleNotificationClose,
            autoHideDuration: 4000
          }
        );
      }
      else if (commonState.snackbar_notification_type === 'success') {
        enqueueSnackbar(commonState.snackbar_notification,
          {
            variant: 'success',
            onClose: handleNotificationClose,
            autoHideDuration: 4000
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonState.snackbar_notification]);

  useEffect(() => {
    if (session.error !== '') {
      if ((session.error_type === 'general')) {
        enqueueSnackbar(session.error,
          {
            variant: 'error',
            onClose: handleNotificationClose,
            autoHideDuration: 4000
          }
        );
      }
      else if (session.error_type === 'message') {
        enqueueSnackbar(session.error,
          {
            variant: 'success',
            onClose: handleNotificationClose,
            autoHideDuration: 4000
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.error]);

  const handleNotificationClose = (event, reason) => {
    /*if (reason === 'clickaway') {
      return;
    }*/
    dispatch(hideSnackBarNotifications(commonState.snackbar_notification_type));
    dispatch(hideError());
  };

  return (
    <div></div>

  );
}


export default NotificationToaster;
